<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-overflow-y-scroll">
      <table class="ts-w-full">
        <thead class="ts-w-full">
          <tr class="ts-bg-black">
            <th
              class="ts-px-4 ts-w-4 ts-py-2 ts-border-t ts-border-b ts-uppercase ts-text-center ts-whitespace-no-wrap"
              style="background-color: #f8f8f9"
            >
              {{ $t('no') }}
            </th>
            <th
              v-for="(col, index) in columns"
              :key="index"
              class="ts-px-4 ts-py-2 ts-border-t ts-border-b ts-uppercase ts-whitespace-no-wrap"
              :class="col.class"
              :style="{
                'background-color': '#f8f8f9',
                'min-width': col.minWidth ? col.minWidth + 'px' : 'auto',
                width: col.width ? col.width + 'px' : 'auto'
              }"
            >
              <div
                :class="
                  col.slot == 'action'
                    ? 'ts-flex ts-items-center ts-justify-center'
                    : ''
                "
              >
                <p
                  :class="col.sortable ? 'hover: ts-cursor-pointer' : ''"
                  class="ts-mb-0"
                  @click.prevent="sortByColumn(col.sortKey)"
                >
                  {{ col.title }}
                  <span v-if="col.sortable" class="ivu-table-sort">
                    <i
                      :class="getSortClass(col.sortKey) == 'asc' ? 'on' : ''"
                      class="ivu-icon ivu-icon-md-arrow-dropup"
                    ></i
                    ><i
                      :class="getSortClass(col.sortKey) == 'desc' ? 'on' : ''"
                      class="ivu-icon ivu-icon-md-arrow-dropdown"
                    ></i
                  ></span>
                </p>
                <button
                  @click.prevent="onClickSearch"
                  v-if="isShowIconSearch && col.slot == 'action'"
                  class="ts-ml-4 ts-bg-blue-600 ts-px-2 ts-rounded ts-outline-none focus:ts-outline-none"
                >
                  <Icon type="ios-search" class="ts-text-white" />
                </button>
              </div>
            </th>
          </tr>
          <tr class="ts-border-b" v-show="isShowSearch">
            <th style="background-color: #f8f8f9"></th>
            <th
              class="ts-px-4 ts-py-2"
              v-for="(col, index) in columns"
              :key="index"
              :style="{
                'background-color': '#f8f8f9',
                'min-width': col.minWidth ? col.minWidth + 'px' : 'auto',
                width: col.width ? col.width + 'px' : 'auto'
              }"
              :class="col.class"
            >
              <input
                ref="searchInput"
                v-model="model[col.keySearch]"
                v-if="col.keySearch && !col.filters"
                :placeholder="col.title"
                type="text"
                class="ts-border ts-rounded ts-outline-none ts-px-2 ts-py-1 ts-w-full"
                @keypress.enter="onClickGo"
              />
              <Select
                v-if="col.keySearch && col.filters"
                ref="searchInput"
                name="searchInput"
                id="searchInput"
                v-model="model[col.keySearch]"
                multiple
                :filterable="true"
                :filter-by-label="true"
                :max-tag-count="1"
                size="small"
              >
                <Option
                  v-for="filter in col.filters"
                  :value="filter.value"
                  :key="filter.value"
                  :label="filter.label"
                >
                  {{ filter.label }}
                </Option>
              </Select>
              <button
                @click.prevent="onClickGo"
                v-if="isShowIconSearch && col.slot == 'action'"
                class="ts-bg-blue-400 ts-font-bold ts-px-3 ts-py-1 ts-text-white ts-rounded"
              >
                {{ $t('go') }}
              </button>
              <button
                @click.prevent="onClickClear"
                v-if="isShowIconSearch && col.slot == 'action'"
                class="ts-bg-red-400 ts-font-bold ts-px-2 ts-py-1 ts-text-white ts-rounded ts-ml-1"
              >
                {{ $t('clear') }}
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="ts-border-b"
            v-for="(item, index) in resources"
            :key="index"
          >
            <td class="ts-text-center">{{ index + 1 }}</td>
            <template v-for="(colB, _colIndex) in columns" class="ts-w-full">
              <td class="ts-px-4" :class="colB.class" v-if="colB.slot">
                <slot :name="colB.slot" :row="item" :index="index"></slot>
              </td>
              <td
                class="ts-px-4 ts-py-2 ts-whitespace-no-wrap"
                :class="colB.class"
                v-else
              >
                {{ item[colB.key] }}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </ts-loading-banner>
</template>

<script>
import { orderBy } from 'lodash'
export default {
  name: 'TsTableFilterV2',
  props: ['columns', 'data', 'loading'],
  data() {
    return {
      isShowSearch: false,
      model: {},
      sortKey: '',
      sortBy: ''
    }
  },
  computed: {
    isShowIconSearch() {
      return this.columns.filter(c => c.keySearch !== undefined).length
    },
    resources() {
      return orderBy(this.data, [this.sortKey], [this.sortBy])
    }
  },
  methods: {
    sortByColumn(column) {
      if (this.sortKey === column) {
        this.sortBy = this.sortBy === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = column
        this.sortBy = 'asc'
      }
    },
    getSortClass(column) {
      if (this.sortKey === column) {
        return this.sortBy
      }
      return ''
    },
    onClickSearch() {
      this.isShowSearch = !this.isShowSearch
      if (this.isShowSearch) {
        const searchColumn = this.columns.filter(s => s.search === true)

        searchColumn.forEach(key => {
          if (key.keySearch) {
            this.model[key.keySearch] = ''
          }
        })
        this.$nextTick(() => this.$refs.searchInput[0].focus())
      }
    },
    onClickGo() {
      this.$emit(
        'search',
        btoa(unescape(encodeURIComponent(JSON.stringify(this.model))))
      )
    },
    onClickClear() {
      this.model = {}
      this.$emit('search', undefined)
    }
  }
}
</script>
<style scoped>
.ivu-select-small.ivu-select-multiple .ivu-select-selection {
  min-height: 27.14px;
  white-space: nowrap;
  overflow: hidden;
}
.ivu-select-multiple .ivu-select-selection .ivu-select-placeholder {
  font-size: 12px;
  padding-top: 1px;
  padding-bottom: 1px;
}
.ivu-select-dropdown {
  margin: 0;
  padding: 0;
}
.ivu-select-item {
  padding: 1px 16px;
  font-size: 12px !important;
  font-weight: 500;
}
.ivu-select-arrow {
  display: none !important;
}
.ivu-select-small.ivu-select-multiple .ivu-select-selection {
  padding-right: 4px !important;
  font-weight: 500;
}
.ivu-select-small .ivu-select-input,
.ivu-select-small.ivu-select-multiple .ivu-select-input {
  width: 0px;
}
</style>
